import { useContext } from 'react';
import { SnackbarMessengerCtx } from './SnackbarProvider';

const useSnackBars = () => {
  const { addSnackbarMessage, removeSnackbarMessage } = useContext(SnackbarMessengerCtx);
  return { addSnackbarMessage, removeSnackbarMessage };
};

export default useSnackBars;
